import { Agent } from "@/types/agent";
import { AgentData } from "@/types/agentTypes";
import { iconMap } from "@/config/defaultAgents";

export const mapAgentWithIcon = (agent: AgentData): Agent => ({
  ...agent,
  icon: iconMap[agent.iconName as keyof typeof iconMap] || iconMap.Brain,
  preferredApi: agent.preferredApi || "mistral",
  openaiApiKey: agent.openaiApiKey || "",
  geminiApiKey: agent.geminiApiKey || "",
  apiKey: agent.apiKey || ""
});

export const validateApiKeyFormat = (key: string, provider: string): boolean => {
  if (!key) return false;
  
  switch (provider) {
    case 'mistral':
      return key.startsWith('mis_') && key.length > 30;
    case 'openai':
      return key.startsWith('sk-') && key.length > 40;
    case 'gemini':
      return key.length > 20;
    default:
      return false;
  }
};